const initBannerVideo = () => {
	const banner = document.querySelector('.home-banner');
	const videoWrapepr = banner.querySelector('.wp-block-video');
	const video = videoWrapepr.querySelector('video');

	const playButton = document.createElement('img');
	playButton.classList.add('play-button');
	playButton.src = '/wp-content/themes/custom-astra/dist/img/home-play-button.svg';
	videoWrapepr.before(playButton);

	document.addEventListener('click', (e) => {
		if (!videoWrapepr.contains(e.target) && !playButton.contains(e.target) && banner.classList.contains('video-playing')) {
			banner.classList.remove('video-playing');
			video.pause();
			video.currentTime = 0;
		}
	});

	playButton.addEventListener('click', () => {
		banner.classList.add('video-playing');
		video.play();
		// play in fullscreen
		if (video.requestFullscreen) {
			video.requestFullscreen();
		} else if (video.mozRequestFullScreen) {
			video.mozRequestFullScreen();
		} else if (video.webkitRequestFullscreen) {
			video.webkitRequestFullscreen();
		} else if (video.msRequestFullscreen) {
			video.msRequestFullscreen();
		}
	});

	video.addEventListener('ended', () => {
		banner.classList.remove('video-playing');
		// exit video fullscreen
		if (document.exitFullscreen) {
			document.exitFullscreen();
		} else if (document.mozCancelFullScreen) {
			document.mozCancelFullScreen();
		} else if (document.webkitExitFullscreen) {
			document.webkitExitFullscreen();
		} else if (document.msExitFullscreen) {
			document.msExitFullscreen();
		}
	});

}

document.addEventListener('DOMContentLoaded', function() {
	initBannerVideo();
});
const createParallaxPills = (parallaxPillsContainer) => {
	const pillsCount = parallaxPillsContainer.classList.contains('parallax-pills-1') ? 3 : 4;

	for (let i = pillsCount; i > 0; i--) {
		const parallaxPill = document.createElement('div');
		parallaxPill.classList.add('parallax-pill', `parallax-pill-` + i);
		parallaxPillsContainer.appendChild(parallaxPill);
	}

	return parallaxPillsContainer.querySelectorAll('.parallax-pill');
}

const initParallaxPillss = () => {
	// get all elements with class parallax-pills-*
	const parallaxPillsContainers = document.querySelectorAll('[class*=parallax-pills-]');
	parallaxPillsContainers.forEach((container) => {
		// if pills not created, create them
		let parallaxPills = container.querySelectorAll('.parallax-pill');
		if (parallaxPills.length === 0) {
			parallaxPills = createParallaxPills(container);
		}

		const parallaxPillsArray = Array.from(parallaxPills);
		const pillsCount = parallaxPillsArray.length;

		// get closest .parallax-pills-parent
		let offsetTop = container.offsetTop;
		const parent = container.closest('.parallax-pills-parent');
		if(parent) {
			offsetTop = parent.offsetTop;
		}

		parallaxPillsArray.forEach((pill, index) => {
			const scrollValue = window.scrollY - offsetTop;
			index+= 1;
			pill.style.transform = `translateY(${(scrollValue * index) / (pillsCount + 1) + index * 10}px)`;
		});

		window.addEventListener('scroll', () => {
			parallaxPillsArray.forEach((pill, index) => {
				const scrollValue = window.scrollY - offsetTop;
				index+= 1;
				pill.style.transform = `translateY(${(scrollValue * index) / (pillsCount + 1) + index * 10}px)`;
			});
		});
	});
}

document.addEventListener('DOMContentLoaded', function() {
	initParallaxPillss();
});
const fixProductVariationDefaultOption = () => {
	const productVariationWrapper = document.querySelector('.ast-variation-button-group');
	if(!productVariationWrapper) {
		return;
	}
	const activeOption = productVariationWrapper.querySelector('.ast-single-variation.active');
	// if no active option, select first option
	if (!activeOption) {
		const firstOption = productVariationWrapper.querySelector('.ast-single-variation');
		firstOption.click();
	}
}

const customQuantityButtons = () => {
	const quantityInput = document.querySelector('.woocommerce-variation-add-to-cart .quantity input[type="number"]');
	if(!quantityInput) {
		return;
	}
	const quantityMinus = document.createElement('button');
	const quantityPlus = document.createElement('button');
	quantityMinus.classList.add('quantity-minus');
	quantityMinus.innerHTML = '-';
	quantityPlus.classList.add('quantity-plus');
	quantityPlus.innerHTML = '+';
	quantityInput.before(quantityMinus);
	quantityInput.after(quantityPlus);

	quantityMinus.addEventListener('click', (e) => {
		e.preventDefault();
		if (quantityInput.value > 1) {
			quantityInput.value = parseInt(quantityInput.value) - 1;
		}
	});

	quantityPlus.addEventListener('click', (e) => {
		e.preventDefault();
		quantityInput.value = parseInt(quantityInput.value) + 1;
	});
}

document.addEventListener('DOMContentLoaded', function() {
	fixProductVariationDefaultOption();
	customQuantityButtons();
});